import {
  Checkbox,
  FormControl,
  FormHelperText,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
} from "@mui/material";
import type { PlaywrightTest } from "./playwright-api";
import { testRowKey } from "./run-test-selection";

interface RunTestFilterProps {
  tests: PlaywrightTest[];
  value: string[];
  onChange: (value: string[]) => void;
}

const RunTestFilter = ({ tests, value, onChange }: RunTestFilterProps) => {
  const summary =
    value.length === 0 || value.length === tests.length
      ? "All tests"
      : value.length === 1
        ? (tests.find((test) => testRowKey(test) === value[0])?.title || "1 test")
        : `${value.length} tests`;

  return (
    <FormControl size="small" fullWidth>
      <InputLabel id="run-test-filter-label">Tests</InputLabel>
      <Select
        labelId="run-test-filter-label"
        label="Tests"
        multiple
        value={value}
        renderValue={() => summary}
        onChange={(event) => {
          const next = event.target.value as string[];
          onChange(next.length === tests.length ? [] : next);
        }}
      >
        {tests.map((test) => {
          const key = testRowKey(test);
          return (
            <MenuItem key={key} value={key}>
              <Checkbox checked={value.includes(key)} />
              <ListItemText primary={test.title} secondary={test.spec} />
            </MenuItem>
          );
        })}
      </Select>
      <FormHelperText>
        Sidebar picks one test. Use this list to compare several.
      </FormHelperText>
    </FormControl>
  );
};

export default RunTestFilter;
